import dynamic from 'next/dynamic';
import { ComponentType } from 'react';
import { CommonBannerProps } from '../AllTherapists/components/banners/BannerBase';

const AskonaBanner = dynamic(
  import('../AllTherapists/components/banners/AskonaBanner'),
);
const AnxietyBanner = dynamic(
  import('../AllTherapists/components/banners/AnxietyBanner'),
);
const DepressionBanner = dynamic(
  import('../AllTherapists/components/banners/DepressionBanner'),
);
const DivorceBanner = dynamic(
  import('../AllTherapists/components/banners/DivorceBanner'),
);
const FoodProblemsBanner = dynamic(
  import('../AllTherapists/components/banners/FoodProblemsBanner'),
);
const LonelinessBanner = dynamic(
  import('../AllTherapists/components/banners/LonelinessBanner'),
);
const LossBanner = dynamic(
  import('../AllTherapists/components/banners/LossBanner'),
);
const PregnancyBanner = dynamic(
  import('../AllTherapists/components/banners/PregnancyBanner'),
);
const RelocationBanner = dynamic(
  import('../AllTherapists/components/banners/RelocationBanner'),
);
const SelfCriticismBanner = dynamic(
  import('../AllTherapists/components/banners/SelfCriticismBanner'),
);

interface DiseaseBannerLink {
  name: string | string[]; // Hardcoded, but should be changed later to recieve banners from backend, or something like this
  Component: ComponentType<CommonBannerProps>;
  isAskona?: boolean; // Not sure why we need this, but AllTherapists page requires sleep problems disease id
}

export const linkedDiseaseBanners: DiseaseBannerLink[] = [
  {
    name: 'Проблема со сном',
    Component: AskonaBanner,
    isAskona: true,
  },
  {
    name: 'Тревога, стресс',
    Component: AnxietyBanner,
  },
  {
    name: 'Депрессия',
    Component: DepressionBanner,
  },
  {
    name: 'Утрата близких/горе/потеря',
    Component: LossBanner,
  },
  {
    name: 'Проблема с питанием',
    Component: FoodProblemsBanner,
  },
  {
    name: 'Потеря любимого человека (Развод/расставание)',
    Component: DivorceBanner,
  },
  {
    name: 'Зажатость/неуверенность в себе/нестабильная самооценка',
    Component: SelfCriticismBanner,
  },
  {
    name: ['Изоляция/одиночество', 'Проблемы в семье или отношениях'],
    Component: LonelinessBanner,
  },
  {
    name: 'Беременность/подготовка к родам/материнство',
    Component: PregnancyBanner,
  },
  {
    name: 'Переезд/релокация/эмиграция',
    Component: RelocationBanner,
  },
];
